// extracted by mini-css-extract-plugin
export default {"notice-box":"NoticeText_notice-box__Mr4LV","notice-box-text":"NoticeText_notice-box-text__lKR4g"};